import { render, staticRenderFns } from "./ResearchList.vue?vue&type=template&id=57196a6d&"
import script from "./ResearchList.vue?vue&type=script&lang=js&"
export * from "./ResearchList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports